import { useState } from "react";
import { Box, FileText, Linkedin, Download } from "lucide-react";
import { PROFILE, ROLES, HERO_STATS, HERO_CERTS } from "../../data/content";
import { CountUp } from "./CountUp";
import { track } from "../../lib/track";

export const Hero = () => {
  const [imgError, setImgError] = useState(false);
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="hero dark-zone" id="about" aria-labelledby="hero-heading">
      <div className="hero-bg" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-content container">
        <div className="hero-text">
          <div className="hero-eyebrow">
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--primary)" }} />
            Available for Consulting Engagements
          </div>
          <h1 className="hero-name" id="hero-heading">Augustus<br /><em>Emenogu</em></h1>
          <p className="hero-tagline">
            MERLA Executive converting complex evidence into funding decisions, policy change,
            and program transformation — across 73 countries, 5 global regions, 20+ years.
          </p>
          <div className="hero-roles" role="list" aria-label="Professional roles">
            {ROLES.map((r) => (
              <span key={r} className="role-badge" role="listitem">{r}</span>
            ))}
          </div>
          <div className="hero-ctas">
            <a href={`${process.env.REACT_APP_BACKEND_URL}/api/capability-statement`}
               className="btn-primary" data-testid="hero-capability-btn"
               target="_blank" rel="noopener noreferrer"
               onClick={() => track("capability_download")}>
              <Download size={16} /> Capability Statement
            </a>
            <a href="#services" className="btn-secondary" data-testid="hero-services-btn"
               onClick={(e) => { e.preventDefault(); go("#services"); }}>
              <Box size={16} /> Explore Services
            </a>
            <a href="#portfolio" className="btn-secondary" data-testid="hero-portfolio-btn"
               onClick={(e) => { e.preventDefault(); go("#portfolio"); }}>
              <FileText size={16} /> View Work Samples
            </a>
            <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer"
               className="btn-secondary" data-testid="hero-linkedin-btn">
              <Linkedin size={16} /> LinkedIn
            </a>
          </div>
        </div>

        <div className="hero-card">
          {!imgError ? (
            <img src={PROFILE.photo} onError={() => setImgError(true)}
                 alt="Augustus Emenogu — professional headshot" className="hero-photo"
                 width="80" height="80" loading="eager" />
          ) : (
            <div style={{ width: 80, height: 80, borderRadius: "50%",
              background: "linear-gradient(135deg,var(--primary),var(--accent-teal))",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "var(--font-display)", fontSize: "1.8rem", color: "#0d1117",
              marginBottom: "var(--space-4)" }}>AE</div>
          )}
          <div className="hero-card-name">Augustus Emenogu</div>
          <div className="hero-card-title">MERLA Executive · Evidence Broker · Ghana &amp; Nigeria</div>
          <div className="hero-stats-grid" role="list">
            {HERO_STATS.map((s) => (
              <div className="stat-item" role="listitem" key={s.label}>
                <CountUp className="stat-number" value={s.count} suffix={s.suffix} />
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
          <div className="hero-certifications" role="list" aria-label="Professional certifications">
            {HERO_CERTS.map((c) => (
              <span key={c} className="cert-badge" role="listitem">{c}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
